<template>
  <div>
    <div class="panel-heading order-heading-with-stats">
      <h4 class="panel-title">{{ $t('orders.approvedOrdersTitle') }}</h4>

      <div class="order-heading-right">
        <div class="order-toolbar-buttons">
          <a class="order-toolbar-btn" :class="{ 'order-toolbar-btn--icon-only': !showButtonLabels }" @click="toggleFiltersVisible">
            <i class="material-icons">{{ showFilters ? 'expand_less' : 'expand_more' }}</i>
            <span v-if="showButtonLabels">{{ $t('orders.filtersToggleLabel') }}</span>
          </a>
          <a class="order-toolbar-btn" :class="{ 'order-toolbar-btn--icon-only': !showButtonLabels }" @click="reloadTable">
            <i class="material-icons">cached</i>
            <span v-if="showButtonLabels">{{ $t('datatable.reloadShortLabel') }}</span>
          </a>
          <a v-if="$_has_perm('purchase_approved_order')" class="order-toolbar-btn" :class="{ 'order-toolbar-btn--icon-only': !showButtonLabels }" @click="confirmPurchaseAll()">
            <i class="material-icons" style="color:#006b8d">add_shopping_cart</i>
            <span v-if="showButtonLabels">{{ $t('orders.sortByPurchase') }}</span>
          </a>
          <a class="order-toolbar-display-toggle" @click="$_toggle_toolbar_button_display()">
            <i class="material-icons">{{ showButtonLabels ? 'label_off' : 'label' }}</i>
          </a>
        </div>

        <div class="order-stats-row order-stats-row--compact">
          <div class="order-stat-card">
            <div class="order-stat-icon order-stat-icon--blue"><i class="material-icons">list_alt</i></div>
            <div class="order-stat-text">
              <span class="order-stat-label">{{ $t('reports.totalOrders') }}</span>
              <span class="order-stat-value">{{ summaryTotalOrders }}</span>
            </div>
          </div>
          <div class="order-stat-card">
            <div class="order-stat-icon order-stat-icon--green"><i class="material-icons">attach_money</i></div>
            <div class="order-stat-text">
              <span class="order-stat-label">{{ $t('printLogs.totalAmountLabel') }}</span>
              <span class="order-stat-value">$ {{ summaryTotalAmount.toFixed(2) }}</span>
              <span v-if="orderIds.length > 0" class="order-stat-note">({{ orderIds.length }} selected)</span>
              <span v-else-if="!filterMade" class="order-stat-note">({{ $t('orders.currentPageScopeNote') }})</span>
            </div>
          </div>
          <div class="order-stat-card">
            <div class="order-stat-icon order-stat-icon--purple"><i class="material-icons">today</i></div>
            <div class="order-stat-text">
              <span class="order-stat-label">{{ $t('adminDashboard.ordersTodayLabel') }}</span>
              <span class="order-stat-value">{{ ordersTodayCount }}</span>
              <span class="order-stat-note">({{ $t('orders.currentPageScopeNote') }})</span>
            </div>
          </div>
          <div class="order-stat-card">
            <div class="order-stat-icon order-stat-icon--orange"><i class="material-icons">payment</i></div>
            <div class="order-stat-text">
              <span class="order-stat-label">{{ $t('adminDashboard.pendingPaymentsLabel') }}</span>
              <span class="order-stat-value">{{ pendingPaymentsCount }}</span>
              <span class="order-stat-note">({{ $t('orders.currentPageScopeNote') }})</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="panel-body"
      style="display: block"
    >
      <div class="row">
        <preDatatableComponent
          ref="preDatatable"
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :hideReloadButton="true"
          :collapsibleFilters="true"
          :filtersVisible="showFilters"
          :confirmPurchaseAll="confirmPurchaseAll"
          :tableData="tableData"
          :permissions="{
            purchase_permission: 'purchase_approved_order',
          }"
          :resetGetResults="resetGetResults"
          :searchMe="searchMe"
          :enableCustomerSearchSuggestions="true"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :resetGetResults2="resetGetResults2"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :storageKey="'cols_approvedOrder_v2'"
          :defaultHideCol="defaultHideCol"
          :resultsVersion="resultsVersion"
          :filterMade="filterMade"
          :totalResult="totalResult"
          :warehouseFilterItems="warehouses"
          :warehouseFilterChange="handleWarehouseFilter"
          :platformFilterItems="platformFilterItems"
          :platformFilterChange="handlePlatformFilter"
          @branch-edit="branchEdit"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <div class="row text-center">
            <span
              id="test-editable"
              style="opacity: 0"
            ></span>
          </div>

          <div
            v-if="orderIds.length > 0"
            class="row text-center"
          >
            <h5
              class="ma-0"
              style="font-weight: bold"
            >
              {{ $t('orders.sumOfSelectedOrdersLabel') }}: {{ $t('columns.purchaseCost') }}: {{ sumOfSelectedOrders.toFixed(3) }}, {{ $t('reports.totalCost') }}: {{ sumOfSelectedOrdersTotalCost.toFixed(3) }} ({{ (sumOfSelectedOrdersTotalCost - sumOfSelectedOrders).toFixed(2) }})
            </h5>
          </div>

          <div class="table-responsive oc-table-shell">
          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
            :checkAll="checkAll"
            :unCheckAll="unCheckAll"
          >
            <tbody>
              <tr
                v-for="(r, index) in apiResults"
                :key="r.order_id"
                :style="orderIds.find((x) => x == r.order_id) ? 'background-color: #FFF9C4' : ''"
              >
                <td>
                  <input
                    :id="'cb' + index"
                    type="checkbox"
                    :value="r.order_id"
                    v-model="orderIds"
                  />
                </td>
                <td class="oc-cell hover-container">
                  <div class="oc-order-number">#{{ r.theOrderID }}</div>
                  <div class="oc-order-sub"><view-order-users :orderData="r" /></div>
                </td>
                <td class="oc-cell ws-nowrap">
                  <customer-device-icon :orderSource="r.order_source" />
                  <img v-if="r.profile_image" :src="r.profile_image && r.profile_image.startsWith('http') ? r.profile_image : `${$_image_path()}${r.profile_image}`" class="customer-profile-image" />
                  <span class="customer-name-stack">
                    <span v-if="r.full_name && r.full_name.trim().split(/\s+/).length > 3" style="word-break: break-word; white-space: pre-line;">
                      {{ r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n') }}
                    </span>
                    <span v-else>
                      {{ r.full_name }}
                    </span>
                    <span v-if="r.customer_id_fk" class="oc-customer-id">ID: {{ r.customer_id_fk }}</span>
                    <span v-if="r.phone_number" class="customer-phone-line">{{ r.phone_number }}</span>
                    <span v-if="r.phone_number_2" class="customer-phone-line">{{ r.phone_number_2 }}</span>
                  </span>
                  <open-whatsapp-and-viber :phoneNumber="r.phone_number" />
                </td>
                <td class="oc-cell">
                  <div class="oc-item-name">{{
                    r.product_name.substr(0, 35) +
                      (r.product_name.length > 35 ? '...' : '')
                  }}</div>
                  <div class="oc-item-sub" v-if="r.brand">{{ $t('columns.brand') }}: <strong>{{ r.brand }}</strong></div>
                  <a v-if="r.product_url" :href="r.product_url" target="_blank" rel="noopener noreferrer" class="oc-item-link">
                    <i class="material-icons">link</i> {{ $t('columns.url') }}
                  </a>
                </td>
                <td class="oc-cell oc-product-cell">
                  <img
                    v-if="r.image"
                    :src="r.image.startsWith('http') ? r.image : `${$_image_path()}${r.image}`"
                    class="oc-thumb"
                    @click="lightboxImage = r.image.startsWith('http') ? r.image : `${$_image_path()}${r.image}`; lightboxOpen = true"
                  />
                  <span v-else class="oc-thumb-placeholder">—</span>
                </td>
                <td class="oc-cell">
                  <span class="oc-status-chip" style="background:#6EADBC; color:#003647;">{{ $_status_label(r.status) }}</span>
                  <div class="oc-location-line" v-if="r.country">
                    <i class="material-icons oc-location-icon">place</i>{{ r.country }}<span v-if="r.transportation_type_obj"> · {{ r.transportation_type_obj.name.replace('Transportation', '') }}</span>
                  </div>
                </td>
                <td class="combined-cell-td oc-cell">
                  <div class="combined-cell">
                    <div><span class="combined-cell-label">{{ $t('columns.price') }}:</span> {{ r.item_price ? '$' + r.item_price : '—' }}</div>
                    <div><span class="combined-cell-label">{{ $t('columns.shipping') }}:</span> {{ r.internal_shipping_handling ? '$' + r.internal_shipping_handling : '—' }}</div>
                    <div><span class="combined-cell-label">{{ $t('columns.total') }}:</span> {{ r.total_amount ? '$' + r.total_amount : '—' }}</div>
                    <div class="combined-cell-divider"></div>
                    <div :class="{ 'qty-flag': Number(r.quantity) > 1 }"><span class="combined-cell-label">{{ $t('columns.qty') }}:</span> {{ r.quantity || '—' }}</div>
                    <div><span class="combined-cell-label">{{ $t('columns.size') }}:</span> {{ r.size || '—' }}</div>
                  </div>
                </td>
                <td class="oc-cell hover-container" style="min-width: 150px">
                  <view-order-dates :orderData="r" stack-time />
                  <span
                    v-if="r.payment_status"
                    class="oc-payment-chip"
                    :style="{ background: paymentStatusColor(r.payment_status, r.invoice_edit_count).bg, color: paymentStatusColor(r.payment_status, r.invoice_edit_count).color }"
                  >{{ paymentStatusLabel(r.payment_status) }}</span>
                </td>
                <td class="oc-cell oc-actions-cell">
                  <div class="oc-actions-grid">
                    <a
                      v-if="$_has_perm('view_order_detail')"
                      class="oc-action-btn"
                      :tooltip="$t('orders.viewDetails')"
                      @click="initDetail('modal_showApp', r.order_id)"
                    >
                      <i class="material-icons" style="color: #01579b">aspect_ratio</i>
                    </a>
                    <a
                      v-if="$_has_perm('process_order')"
                      class="oc-action-btn"
                      :tooltip="$t('orders.processOrderTooltip')"
                      @click="openProcessOrderModal(r)"
                    >
                      <i class="material-icons" style="color: #424242">settings</i>
                    </a>
                    <a
                      v-if="$_has_perm('purchase_approved_order')"
                      class="oc-action-btn"
                      :tooltip="$t('orders.purchaseThisOrderTooltip')"
                      @click="openPurchaseOrderModal(r)"
                    >
                      <i class="material-icons" style="color: #2e7d32">add_shopping_cart</i>
                    </a>
                    <a
                      v-if="$_has_perm('refund_approved_order')"
                      class="oc-action-btn"
                      :tooltip="$t('orders.refundThisOrderTooltip')"
                      @click="openRefundOrderModal(r.order_id, r.total_amount)"
                    >
                      <i class="material-icons" style="color: #c62828">block</i>
                    </a>
                    <a
                      v-if="$_has_perm('cancel_approved_order')"
                      class="oc-action-btn"
                      :tooltip="$t('orders.cancelThisOrder')"
                      @click="openCancelingOrderModal(r.order_id, r.total_amount)"
                    >
                      <i class="material-icons" style="color: #c62828">cancel</i>
                    </a>
                    <a
                      v-if="$_has_perm('copy_approved_order_to_new_order')"
                      class="oc-action-btn"
                      :tooltip="$t('orders.copyToNewOrderTooltip')"
                      @click="copyOrderToNewOrder(r)"
                    >
                      <i class="material-icons" style="color: #6a1b9a">content_copy</i>
                    </a>
                    <a
                      v-if="$_has_perm('add_partial_refund')"
                      class="oc-action-btn"
                      :tooltip="$t('orders.partialRefundTooltip')"
                      @click="openPartialRefundOrderModal(r.order_id, r.total_amount)"
                    >
                      <i class="fa fa-registered" style="color: #ff5722"></i>
                    </a>
                    <a
                      v-if="$_has_perm('add_order_case')"
                      class="oc-action-btn"
                      @click="openCreateOrderCaseModal(r)"
                      :tooltip="$t('orders.createCaseTooltip')"
                    >
                      <i class="fa fa-folder-open" style="color: #555"></i>
                    </a>
                  </div>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  > {{ $t('common.noResultsFound') }} </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>
          </div>

          <!-- Mobile card layout — mirrors every desktop column, no horizontal scroll -->
          <div v-if="isMobile" class="mobile-orders-container">
            <div
              v-for="(r, index) in apiResults"
              :key="r.order_id"
              class="mobile-order-card"
              :style="orderIds.find(x => x == r.order_id) ? 'border-left-color:#FBC02D; background:#FFF9C4;' : ''"
            >
              <!-- Card header: checkbox + OrderID + Status badge -->
              <div class="moc-header">
                <input
                  :id="'cb' + index"
                  type="checkbox"
                  :value="r.order_id"
                  v-model="orderIds"
                />
                <span class="moc-item-code">{{ r.theOrderID }}</span>
                <span class="moc-status-badge" style="background:#6EADBC; color:#003647;">{{ $_status_label(r.status) }}</span>
              </div>

              <div class="moc-body">
                <!-- User -->
                <div class="moc-row">
                  <span class="moc-label">{{ $t('common.user') }}</span>
                  <span class="moc-value"><view-order-users :orderData="r" /></span>
                </div>

                <!-- Customer -->
                <div class="moc-row">
                  <span class="moc-label">{{ $t('columns.customer') }}</span>
                  <span class="moc-value">
                    <customer-device-icon :orderSource="r.order_source" />
                    <img v-if="r.profile_image" :src="r.profile_image && r.profile_image.startsWith('http') ? r.profile_image : `${$_image_path()}${r.profile_image}`" class="customer-profile-image" />
                    <span v-if="r.full_name && r.full_name.trim().split(/\s+/).length > 3" style="word-break:break-word; white-space:pre-line;">
                      {{ r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n') }}
                    </span>
                    <span v-else>{{ r.full_name }}</span>
                    <open-whatsapp-and-viber :phoneNumber="r.phone_number" />
                  </span>
                </div>

                <!-- Item Name -->
                <div class="moc-row">
                  <span class="moc-label">{{ $t('columns.itemName') }}</span>
                  <span class="moc-value">{{ r.product_name.substr(0, 60) + (r.product_name.length > 60 ? '...' : '') }}</span>
                </div>

                <!-- Brand -->
                <div class="moc-row" v-if="r.brand">
                  <span class="moc-label">{{ $t('columns.brand') }}</span>
                  <span class="moc-value">{{ r.brand }}</span>
                </div>

                <!-- URL -->
                <div class="moc-row">
                  <span class="moc-label">{{ $t('columns.url') }}</span>
                  <span class="moc-value">
                    <a v-if="r.product_url" :href="r.product_url" target="_blank" rel="noopener noreferrer" style="color:#01579B;">
                      <i class="material-icons" style="font-size:20px; vertical-align:middle;">link</i>
                    </a>
                    <span v-else style="color:#bbb;">—</span>
                  </span>
                </div>

                <!-- Image -->
                <div class="moc-row" v-if="r.image">
                  <span class="moc-label">{{ $t('columns.image') }}</span>
                  <span class="moc-value">
                    <img
                      :src="r.image.startsWith('http') ? r.image : `${$_image_path()}${r.image}`"
                      style="width:80px; height:80px; object-fit:cover; border-radius:4px; cursor:pointer;"
                      @click="lightboxImage = r.image.startsWith('http') ? r.image : `${$_image_path()}${r.image}`; lightboxOpen = true"
                    />
                  </span>
                </div>

                <!-- Warehouse -->
                <div class="moc-row">
                  <span class="moc-label">{{ $t('columns.warehouse') }}</span>
                  <span class="moc-value">{{ r.country || '—' }}</span>
                </div>

                <!-- Price | Shipping | Total -->
                <div class="moc-row--3col">
                  <div>
                    <span class="moc-label">{{ $t('columns.price') }}</span>
                    <span class="moc-value">{{ r.item_price ? '$' + r.item_price : '—' }}</span>
                  </div>
                  <div>
                    <span class="moc-label">{{ $t('columns.shipping') }}</span>
                    <span class="moc-value">{{ r.internal_shipping_handling ? '$' + r.internal_shipping_handling : '—' }}</span>
                  </div>
                  <div>
                    <span class="moc-label">{{ $t('columns.total') }}</span>
                    <span class="moc-value">{{ r.total_amount ? '$' + r.total_amount : '—' }}</span>
                  </div>
                </div>

                <!-- Qty | Size -->
                <div class="moc-row--2col">
                  <div :class="{ 'qty-flag': Number(r.quantity) > 1 }">
                    <span class="moc-label">{{ $t('columns.qty') }}</span>
                    <span class="moc-value">{{ r.quantity || '—' }}</span>
                  </div>
                  <div>
                    <span class="moc-label">{{ $t('columns.size') }}</span>
                    <span class="moc-value">{{ r.size || '—' }}</span>
                  </div>
                </div>

                <!-- Date & Time -->
                <div class="moc-row">
                  <span class="moc-label">{{ $t('columns.dateTime') }}</span>
                  <span class="moc-value"><view-order-dates :orderData="r" /></span>
                </div>

                <!-- Item Price in Warehouse Currency -->
                <div class="moc-row moc-currency-block" v-if="localItemPrice(r)">
                  <span class="moc-label">{{ localItemPrice(r).label }}</span>
                  <span class="moc-value">
                    <span class="moc-currency-chip">{{ localItemPrice(r).display }}</span>
                  </span>
                </div>
              </div>

              <!-- Card footer: action buttons (same permissions as desktop) -->
              <div class="moc-actions">
                <a
                  v-if="$_has_perm('view_order_detail')"
                  style="color:#01579B;"
                  :tooltip="$t('orders.viewDetails')"
                  @click="initDetail('modal_showApp', r.order_id)"
                >
                  <i class="material-icons">aspect_ratio</i>
                </a>
                <a
                  v-if="$_has_perm('process_order')"
                  style="color:#424242;"
                  :tooltip="$t('orders.processOrderTooltip')"
                  @click="openProcessOrderModal(r)"
                >
                  <i class="material-icons">settings</i>
                </a>
                <a
                  v-if="$_has_perm('purchase_approved_order')"
                  style="color:#2E7D32;"
                  :tooltip="$t('orders.purchaseThisOrderTooltip')"
                  @click="openPurchaseOrderModal(r)"
                >
                  <i class="material-icons">add_shopping_cart</i>
                </a>
                <a
                  v-if="$_has_perm('refund_approved_order')"
                  style="color:#C62828;"
                  :tooltip="$t('orders.refundThisOrderTooltip')"
                  @click="openRefundOrderModal(r.order_id, r.total_amount)"
                >
                  <i class="material-icons">block</i>
                </a>
                <a
                  v-if="$_has_perm('cancel_approved_order')"
                  style="color:#C62828;"
                  :tooltip="$t('orders.cancelThisOrder')"
                  @click="openCancelingOrderModal(r.order_id, r.total_amount)"
                >
                  <i class="material-icons">cancel</i>
                </a>
                <a
                  v-if="$_has_perm('copy_approved_order_to_new_order')"
                  style="color:#6A1B9A;"
                  :tooltip="$t('orders.copyToNewOrderTooltip')"
                  @click="copyOrderToNewOrder(r)"
                >
                  <i class="material-icons">content_copy</i>
                </a>
                <a
                  v-if="$_has_perm('add_partial_refund')"
                  style="color:#FF5722;"
                  :tooltip="$t('orders.partialRefundTooltip')"
                  @click="openPartialRefundOrderModal(r.order_id, r.total_amount)"
                >
                  <i class="fa fa-registered" style="font-size:1.6em;"></i>
                </a>
                <a
                  v-if="$_has_perm('add_order_case')"
                  @click="openCreateOrderCaseModal(r)"
                  style="color:#555;"
                  :tooltip="$t('orders.createCaseTooltip')"
                >
                  <i class="fa fa-folder-open" style="font-size:1.6rem;"></i>
                </a>
              </div>
            </div>

            <div v-if="alertValue" style="text-align:center; padding:16px;">
              <v-alert type="error" :value="alertValue">{{ $t('common.noResultsFound') }}</v-alert>
            </div>
          </div>

          <!-- Image Lightbox -->
          <v-dialog v-model="lightboxOpen" max-width="600" @input="val => { if (!val) lightboxOpen = false }">
            <v-card style="background:#000; text-align:center; padding:8px;">
              <img
                v-if="lightboxImage"
                :src="lightboxImage"
                style="max-width:100%; max-height:80vh; object-fit:contain; border-radius:4px;"
              />
              <div style="margin-top:8px;">
                <v-btn flat dark @click="lightboxOpen = false">{{ $t('common.close') }}</v-btn>
              </div>
            </v-card>
          </v-dialog>

          <view-order-details
            :detialData="detialData"
            :closeModal="closeModal"
            @open-purchase-modal="handlePurchaseModal"
            @open-refund-modal="handleRefundModal"
            @open-partial-refund-modal="handlePartialRefundModal"
          ></view-order-details>

          <refunding-order
            :refundOrderModal="refundOrderModal"
            :refundOrder="refundOrder"
            :refundData="refundData"
            :theOrderTotalAmount="theOrderTotalAmount"
            :checkAlert="checkAlert"
            :closeRefundOrderModal="closeRefundOrderModal"
            :loading="loading"
            :reasons="reasons"
          ></refunding-order>

          <partial-refunding-order
            :partialRefundOrderModal="partialRefundOrderModal"
            :partialRefundOrder="partialRefundOrder"
            :partialRefundData="partialRefundData"
            :theOrderTotalAmount="theOrderTotalAmount"
            :checkAlert="checkAlert"
            :closePartialRefundOrderModal="closePartialRefundOrderModal"
            :loading="loading"
          ></partial-refunding-order>

          <add-barcode
            :addBarcodeModal="addBarcodeModal"
            :addBarcode="addBarcode"
            :addBarcodeData="addBarcodeData"
            :checkAlert="checkAlert"
            :closeAddBarcodeModal="closeAddBarcodeModal"
          >
          </add-barcode>

          <purchase-order
            :closePurchaseOrderModal="closePurchaseOrderModal"
            :purchaseOrderModal="purchaseOrderModal"
            :successAlert="successAlert"
            :purchaseOrderData="purchaseOrderData"
            :purchaseAll="purchaseAll"
            :purchaseOrder="purchaseOrder"
            :banks="banks"
          ></purchase-order>

          <process-the-order
            v-if="currentProcessOrder"
            ref="processComp"
            :processOrder="processOrder"
            :r="currentProcessOrder"
            :checkAlert="checkAlert"
            :updateData="updateData"
            :calculateTotalAmount="calculateTotalAmount"
            :loading="loading"
            :getResults="getResults"
            :clearProcessOrderData="clearProcessOrderData"
            :theQuantity="theQuantity"
            :itemTypes="itemTypes"
            :warehouses="warehouses"
            :reasons="reasons"
          ></process-the-order>

          <add-edit-order-case
            :addEditOrderCaseModal="addEditOrderCaseModal"
            :formData="formData"
            :isUpdate="isUpdate"
            @close="addEditOrderCaseModal = false"
          />

          <admin-cancel-order
            :closeCancelingOrderModal="closeCancelingOrderModal"
            :cancelOrderModal="cancelOrderModal"
            :cancelAlert="cancelAlert"
            :cancelData="cancelData"
            :cancelingOrder="cancelingOrder"
            :reasons="reasons"
            :willAutoRefund="true"
            :refundAmount="cancelRefundAmount"
          ></admin-cancel-order>

          <div class="row">
            <div class="col-xs-12 text-center oc-pagination">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from './Pagination.vue'
import preDatatableComponent from './preDatatableComponent.vue'
import DatatableVue from './Datatable.vue'
import viewOrderDetails from './viewOrderDetails.vue'
import refundingOrder from './refundingOrder.vue'
import partialRefundingOrder from './partialRefundingOrder.vue'
import addBarcode from './addBarcode.vue'
import purchaseOrder from './purchaseOrder'
import adminCancelOrder from './adminCancelOrder'
import addEditOrderCase from './orderCase/addEditOrderCase.vue'
import processTheOrder from './processTheOrder.vue'
import axios from 'axios'
import swal from 'sweetalert'
import statusHelpers from '../mixins/statusHelpers'
import toolbarButtonDisplay from '../mixins/toolbarButtonDisplay'

export default {
  mixins: [statusHelpers, toolbarButtonDisplay],
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'view-order-details': viewOrderDetails,
    'refunding-order': refundingOrder,
    'add-barcode': addBarcode,
    'purchase-order': purchaseOrder,
    partialRefundingOrder,
    addEditOrderCase,
    'admin-cancel-order': adminCancelOrder,
    'process-the-order': processTheOrder
  },
  mounted() {
    this.$_fetch_statuses()
    this.perPageFix()
    this.getBanks()
    this.getWarehouses()
    this.getReasons()
    this.getItemType()

    if (window.innerWidth <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  computed: {
    sumOfSelectedOrders() {
      let sum = 0
      this.apiResults.filter(order => this.orderIds.includes(order.order_id)).forEach(x => {
        sum += x.item_price * x.quantity + x.national_tax + x.delivery_price
      })

      return sum
    },

    sumOfSelectedOrdersTotalCost() {
      let sum = 0
      this.apiResults.filter(order => this.orderIds.includes(order.order_id)).forEach(x => {
        sum += x.total_amount
      })

      return sum
    },

    summaryTotalOrders() {
      if (this.orderIds.length > 0) return this.orderIds.length
      return this.filterMade
        ? this.apiResults.length
        : (this.pagination.total || this.apiResults.length)
    },
    summaryTotalAmount() {
      return this.apiResults.reduce((sum, r) => sum + (Number(r.total_amount) || 0), 0)
    },
    // Best-effort only: counts within the currently loaded page of apiResults, not a true
    // system-wide count -- hence the "(current page)" note shown alongside it in the stat card.
    ordersTodayCount() {
      const today = new Date().toISOString().split('T')[0]
      return this.apiResults.filter(r => {
        const d = r.confirm_date || r.order_date || r.created_at
        return d && d.substr(0, 10) === today
      }).length
    },
    // Same current-page-only caveat as ordersTodayCount above.
    pendingPaymentsCount() {
      return this.apiResults.filter(r => r.payment_status && r.payment_status !== 'paid').length
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    let sortOrders = {}
    // Grouped columns (redesign, mirrors allOrder.vue's pattern) -- was a flat 17-column
    // list; each grouped cell stacks several related fields (the approved-by user folds
    // into Order Info). Per-column hide now only makes sense at the group level, so
    // defaultHideCol is emptied and storageKey bumped so stale hidden-column selections
    // don't misapply to new positions.
    let columns = [
      { label: '', name: '', text: this.$t('columns.checkBoxColumn'), value: '1' },
      { label: this.$t('columns.orderInfo'), text: this.$t('columns.orderInfo'), value: '2', sortable: true, searchable: true, name: 'theOrderID' },
      { label: this.$t('columns.customer'), text: this.$t('columns.customer'), value: '3', sortable: true, searchable: true, name: 'full_name' },
      { label: this.$t('columns.itemDetails'), text: this.$t('columns.itemDetails'), value: '4', sortable: true, searchable: true, name: 'product_name' },
      { label: this.$t('columns.product'), text: this.$t('columns.product'), value: '5', sortable: false, searchable: false, name: 'image' },
      { label: this.$t('columns.statusLocation'), text: this.$t('columns.statusLocation'), value: '6', sortable: true, searchable: true, name: 'status' },
      { label: this.$t('columns.pricing'), text: this.$t('columns.pricing'), value: '7', sortable: false, searchable: false, name: 'price_all' },
      { label: this.$t('columns.datePayment'), text: this.$t('columns.datePayment'), value: '8', sortable: true, searchable: true, name: 'confirm_date' },
      { label: this.$t('columns.actions'), text: this.$t('columns.actions'), value: '9', sortable: false, searchable: false, name: 'actions' }
    ]
    columns.forEach((column) => {
      sortOrders[column.name] = -1
    })

    return {
      isMobile: false,
      loading: false,
      url: 'api/approved_order',
      refundOrderUrl: 'api/refunding_order',
      purchaseOrderUrl: 'api/purchasing_order',
      orderDetailUrl: 'api/show_order_detail',
      addBarcodeUrl: 'api/add_barcode',
      bankUrl: 'api/get_banks',
      cancelingOrderUrl: 'api/canceling_order_by_admin',
      processOrderUrl: 'api/orders',
      getItemTypeUrl: 'api/get-item-type',
      refundOrderModal: false,
      // Process Order (single instance pattern, mirrors purchasedOrder.vue)
      currentProcessOrder: null,
      theQuantity: { quantity: '' },
      itemTypeResult: [],
      itemTypes: [],
      updateData: {
        item_price: null,
        the_tl_price: null,
        the_aed_price: null,
        the_cny_price: null,
        the_gbp_price: null,
        the_eur_price: null,
        tax: null,
        national_tax: null,
        item_weight: null,
        internal_shipping_handling: null,
        delivery_price: null,
        kreenex_fee: null,
        quantity_charge: null,
        insurance: null,
        total_amount: null,
        from_date: null,
        to_date: null,
        description: '',
        tmp_shipping: null,
        item_weight_lb: null,
        price_weight: null,
        send_sms: false,
        discount: null,
        item_type: '',
        transportation_type: null,
        is_repackage: false,
        is_hold: false,
        other_service: '',
        local_delivery: 0,
        process_note: '',
        customer_process_note: '',
        repackage_price: null,
        hold_price: null,
        other_service_price: null,
        customer_id_fk: null,
        product_name: null,
        product_url: null,
        quantity: null,
        color: null,
        size: null,
        note: null,
        brand: null
      },
      orderIds: [],
      resultsVersion: 0,
      platformFilterItems: [
        { text: this.$t('common.mobileSource'), value: 'mobile' },
        { text: this.$t('common.webSource'), value: 'web' },
        { text: this.$t('common.adminSource'), value: 'admin' }
      ],
      isUpdate: false,
      formData: {},
      addEditOrderCaseModal: false,
      addBarcodeModal: false,
      filterMade: false,
      totalResult: 0,
      purchaseOrderModal: false,
      cancelAlert: false,
      the_order_id: '',
      the_order_id2: '',
      theCancelOrderID: '',
      cancelRefundAmount: null,
      alertValue: false,
      checkAlert: false,
      successAlert: false,
      cancelOrderModal: false,
      queryParameter: true,
      theOrderTotalAmount: '',
      btnsave: true,
      cancelData: {
        cancel_reason: '',
      },
      refundData: {
        send_sms: false
      },
      lightboxImage: null,
      lightboxOpen: false,
      warehouses: [],
      reasons: [],
      partialRefundOrderModal: false,
      partialRefundData: {},
      addBarcodeData: {
        barcode: ''
      },
      purchaseOrderData: {
        bank_id: '',
        item_cost_in_tl: '',
        item_cost_in_usd: '',
        country: '',
        purchase_note: '',
        barcode: null,
        warehouse_date: null,
        from_date: null,
        to_date: null,
        ids: []
      },
      detialData: {
        the_tl_price: '',
        order_id: '',
        discount: '',
        full_name: '',
        email: '',
        phone_number: '',
        c_o_d: '',
        product_url: '',
        product_name: '',
        description: '',
        size: '',
        coupon_percentage: '',
        type: '',
        theOrderID: '',
        status: '',
        color: '',
        quantity: '',
        quantity_charge: '',
        coupon: '',
        qrcode: '',
        barcode: '',
        delivery_type: '',
        item_price: '',
        tax: '',
        item_weight: '',
        internal_shipping_handling: '',
        kreenex_fee: '',
        delivery_price: '',
        insurance: '',
        total_amount: '',
        from_date: '',
        to_date: '',
        confirm_date: '',
        refund_reason: '',
        country: '',
        order_date: '',
        track_number: '',
        note: '',
        item_type: '',
      },
      prevSearchQuery: '',
      apiResults: [],
      detailResults: [],
      bankResults: [],
      banks: [],
      kurdistanBankId: null,
      columns: columns,
      // Grouped cells can't be hidden field-by-field any more -- same tradeoff allOrder.vue made.
      defaultHideCol: [],
      // Hidden by default (per-page preference, same localStorage convention as allOrder.vue).
      showFilters: localStorage.getItem('filtersVisible_approvedOrder') === 'true',
      sortKey: 'order_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: '',
        warehouse_id_fk: '',
        platform: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: '',
      }
    }
  },

  methods: {
    toggleFiltersVisible() {
      this.showFilters = !this.showFilters
      localStorage.setItem('filtersVisible_approvedOrder', this.showFilters ? 'true' : 'false')
    },

    // Replicates preDatatableComponent.vue's own built-in Reload button (now relocated
    // into the panel-heading here) -- reaches into the child's own filter-chip/date-range
    // reset state via $refs since that state lives inside the shared component, not here.
    reloadTable() {
      this.resetGetResults()
      const preDatatable = this.$refs.preDatatable
      if (preDatatable) {
        preDatatable.filterApplied = false
        preDatatable.resetDatePickerDefaults()
        preDatatable.ware = 'Select'
      }
    },

    paymentStatusColor(status, editCount) {
      if (status === 'not_paid' && !Number(editCount)) {
        return { bg: '#E0E0E0', color: '#616161' }
      }
      const map = {
        not_paid: { bg: '#F63049', color: '#FFFFFF' },
        partial_paid: { bg: '#FFC85C', color: '#6B4C00' },
        paid: { bg: '#89D7B7', color: '#1A5940' },
        cancel: { bg: '#FB8C00', color: '#FFFFFF' }
      }
      return map[status] || { bg: '#F5F5F5', color: '#616161' }
    },

    paymentStatusLabel(status) {
      if (!status) return ''
      return status.replace(/_/g, ' ')
    },

    localItemPrice(r) {
      if (r.country === 'Turkey' && r.the_tl_price) return { label: this.$t('customer.itemPrice') + ' TL', display: `${r.the_tl_price} ₺` }
      if (r.country === 'UAE' && r.the_aed_price) return { label: this.$t('customer.itemPrice') + ' AED', display: `${r.the_aed_price} AED` }
      if (r.country === 'China' && r.the_cny_price) return { label: this.$t('customer.itemPrice') + ' CNY', display: `¥${r.the_cny_price}` }
      if (r.country === 'United Kingdom' && r.the_gbp_price) return { label: this.$t('customer.itemPrice') + ' GBP', display: `£${r.the_gbp_price}` }
      if (r.country === 'Germany' && r.the_eur_price) return { label: this.$t('customer.itemPrice') + ' EUR', display: `€${r.the_eur_price}` }
      return null
    },

    openCreateOrderCaseModal(order) {
      this.formData = {
        order_id_fk: order.order_id,
        order: order,
        note: null
      }
      this.isUpdate = false
      this.addEditOrderCaseModal = true
    },

    branchEdit(branches) {
      this.tableData.branches_id = branches.toString()
      this.getResults()
    },

    checkAll() {
      this.orderIds = this.apiResults.map(r => r.order_id)
    },

    unCheckAll() {
      this.orderIds = []
    },

    openCancelingOrderModal(orderId, totalAmount) {
      this.cancelOrderModal = true
      this.theCancelOrderID = orderId
      this.cancelRefundAmount = totalAmount || null
    },

    closeCancelingOrderModal() {
      this.cancelOrderModal = false
      this.cancelAlert = false
      this.cancelRefundAmount = null
      this.cancelData.cancel_reason = ''
    },

    cancelingOrder() {
      let token = localStorage.getItem('access_token')
      axios
        .put(this.cancelingOrderUrl + '/' + this.theCancelOrderID, this.cancelData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.getResults()
          this.cancelAlert = true
          let self = this
          setTimeout(() => {
            self.closeCancelingOrderModal()
          }, 1500)
        })
        .catch(error => {
          swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
        })
    },

    copyOrderToNewOrder(r) {
      swal({
        title: this.$t('orders.copyToNewOrderConfirmTitle'),
        text: this.$t('orders.copyToNewOrderConfirmMessage', { id: r.theOrderID }),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((confirmed) => {
        if (confirmed) {
          let token = localStorage.getItem('access_token')
          axios
            .post('api/orders/' + r.order_id + '/copy_to_new_order', {}, {
              headers: { Authorization: 'Bearer ' + token }
            })
            .then((response) => {
              this.getResults()
              swal({
                title: this.$t('common.done'),
                text: response.data.message,
                icon: 'success',
                timer: 2500,
                buttons: false
              })
            })
            .catch((error) => {
              swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
            })
        }
      })
    },

    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    confirmPurchaseAll() {
      if (this.orderIds.length === 0) {
        swal(this.$t('common.error'), this.$t('orders.pleaseSelectOrderToPurchase'), 'error')
        return
      }

      const today = new Date().toISOString().split('T')[0]
      const d = new Date()
      d.setDate(d.getDate() + 7)
      const todayPlus7 = d.toISOString().split('T')[0]

      // Apply same auto-fill defaults as single-order purchase
      this.purchaseOrderData.bank_id = this.kurdistanBankId
      this.purchaseOrderData.barcode = null
      this.purchaseOrderData.warehouse_date = today
      this.purchaseOrderData.from_date = today
      this.purchaseOrderData.to_date = todayPlus7

      // Sum total_amount per country/currency from selected orders
      const selectedOrders = this.apiResults.filter(o => this.orderIds.includes(o.order_id))
      const totalByCountry = {}
      let grandTotal = 0
      selectedOrders.forEach(o => {
        const country = o.country || 'USA'
        if (!totalByCountry[country]) totalByCountry[country] = 0
        totalByCountry[country] += Number(o.total_amount) || 0
        grandTotal += Number(o.total_amount) || 0
      })

      this.purchaseOrderData.actual_price = Number(grandTotal.toFixed(2))
      this.purchaseOrderData.totalByCountry = totalByCountry
      this.purchaseOrderData.ids = this.orderIds

      this.purchaseOrderModal = true
    },

    handlePurchaseModal(orderData) {
      this.closeModal('modal_showApp') // Close the current modal
      this.openPurchaseOrderModal(orderData) // Open the purchase modal
    },

    handleRefundModal(orderData) {
      this.closeModal('modal_showApp') // Close the current modal
      console.log(orderData)
      this.openRefundOrderModal(orderData.order_id, orderData.total_amount) // Open the purchase modal
    },

    handlePartialRefundModal(orderData) {
      this.closeModal('modal_showApp') // Close the current modal
      console.log(orderData)
      this.openPartialRefundOrderModal(orderData.order_id, orderData.total_amount) // Open the purchase modal
    },

    purchaseAll() {
      let token = localStorage.getItem('access_token')
      axios
        .post('api/purchasing_multiple_order', this.purchaseOrderData, {
          headers: { Authorization: 'Bearer ' + token },
        })
        .then(() => {
          this.getResults()
          swal({
            title: this.$t('common.done'),
            text: this.$t('orders.ordersPurchasedSuccessfully'),
            icon: 'success',
            timer: 1500,
            buttons: false,
          })
          this.closePurchaseOrderModal()
          this.unCheckAll()
          this.orderIds = []
        })
        .catch(() => {
          swal(this.$t('common.error'), this.$t('orders.pleaseRefreshPageAndTryAgain'), 'error')
        })
    },

    resetGetResults2() {
      this.resetGetResults()
    },

    getBanks() {
      let token = localStorage.getItem('access_token')

      axios
        .get(this.bankUrl, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.bankResults = response.data.data
          this.bankResults.forEach((c) => {
            this.banks.push({ text: c.bank_name, value: c.bank_id })
            if (c.bank_code === 'kur') {
              this.kurdistanBankId = c.bank_id
            }
          })
        })
    },

    getWarehouses() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.warehouses = []
          let result = response.data.data
          result.forEach((r) => {
            this.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types, currency: r.currency, estimate_days: r.estimate_days })
          })
        })
    },

    getItemType() {
      let token = localStorage.getItem('access_token')
      axios
        .get(this.getItemTypeUrl, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.itemTypeResult = response.data.data
          this.itemTypeResult.forEach((c) => {
            this.itemTypes.push({
              text: c.type_name,
              value: c.type_name,
              shippingPrice: c.type_int_shipping_price
            })
          })
        })
    },

    // Process Order modal (single instance pattern, mirrors purchasedOrder.vue). The order is
    // already charged at approval (see applyApproveSideEffects()) but has no bank-debit row yet
    // (that's only created at purchase), so OrderController@update's applyOrderTotalCorrection()
    // reconciles the customer's credit for any total_amount diff while simply skipping the
    // bank-ledger sync (it's guarded on finding an existing debit row, which won't exist yet).
    openProcessOrderModal(r) {
      const warehouseObj = this.warehouses.find(w => w.value === r.warehouse_id_fk)
      const enriched = Object.assign({}, r, {
        warehouse: {
          transportation_types: warehouseObj ? warehouseObj.transportation_types : []
        }
      })
      this.currentProcessOrder = enriched
      this.checkAlert = false
      this.clearProcessOrderData()
      this.theQuantity.quantity = r.quantity
      this.updateData.quantity_charge = r.quantity_charge
      // Force a real false->true transition on the child's `dialog` watcher so its reset/
      // prefill logic always re-runs. If a different order's dialog was left open (e.g. a
      // second gear icon clicked before the first was closed), `dialog` is already true and
      // setting it true again is a no-op — the child then keeps showing/validating the
      // previous order's stale updateData, which is what caused the "Int. Shipping" field to
      // show a stray required error on a now-valid value.
      if (this.$refs.processComp) {
        this.$refs.processComp.dialog = false
      }
      this.$nextTick(() => {
        if (this.$refs.processComp) {
          this.$refs.processComp.dialog = true
          this.$refs.processComp.calculateTotalAmount()
          this.$refs.processComp.getExchangeRate()
          this.$refs.processComp.getAEDRate()
          this.$refs.processComp.getCNYRate()
          this.$refs.processComp.getGBPRate()
          this.$refs.processComp.getEURRate()
        }
      })
    },

    calculateTotalAmount() {
      let itemPrice = Number(this.updateData.item_price) || 0
      let shipping = Number(this.updateData.internal_shipping_handling) || 0
      let tax = Number(this.updateData.tax) || 0
      let nationalTax = Number(this.updateData.national_tax) || 0
      let delivery = Number(this.updateData.delivery_price) || 0
      let fee = Number(this.updateData.kreenex_fee) || 0
      let insurance = Number(this.updateData.insurance) || 0
      let qttCharge = Number(this.updateData.quantity_charge) || 0
      let discount = Number(this.updateData.discount) || 0
      let qtt = Number(this.theQuantity.quantity) || 0
      let repackagePrice = Number(this.updateData.repackage_price) || 0
      let holdPrice = Number(this.updateData.hold_price) || 0
      let otherServicePrice = Number(this.updateData.other_service_price) || 0
      const _userData = JSON.parse(localStorage.getItem('user_data') || '{}')
      const _exRate = Number(_userData.ex_rate) || 1
      let localDelivery = (Number(this.updateData.local_delivery) || 0) / _exRate

      let total = (itemPrice + shipping) * qtt + tax + nationalTax + delivery + fee + insurance + qttCharge + localDelivery

      if (this.updateData.is_repackage) total += repackagePrice
      if (this.updateData.is_hold) total += holdPrice
      if (otherServicePrice > 0) total += otherServicePrice
      if (discount > 0) total -= discount

      this.updateData.total_amount = total.toFixed(2)
    },

    clearProcessOrderData() {
      this.updateData.item_price = null
      this.updateData.the_tl_price = null
      this.updateData.the_aed_price = null
      this.updateData.the_cny_price = null
      this.updateData.the_gbp_price = null
      this.updateData.the_eur_price = null
      this.updateData.tax = null
      this.updateData.item_weight = null
      this.updateData.internal_shipping_handling = 0
      this.updateData.delivery_price = null
      this.updateData.kreenex_fee = null
      this.updateData.insurance = null
      this.updateData.total_amount = null
      this.updateData.from_date = null
      this.updateData.to_date = null
      this.updateData.quantity_charge = null
      this.updateData.description = ''
      this.updateData.item_type = ''
      this.updateData.item_weight_lb = null
      this.updateData.discount = null
      this.updateData.send_sms = false
      this.updateData.is_repackage = false
      this.updateData.is_hold = false
      this.updateData.other_service = ''
      this.updateData.repackage_price = null
      this.updateData.hold_price = null
      this.updateData.other_service_price = null
      this.updateData.local_delivery = null
      this.updateData.national_tax = null
      this.updateData.process_note = ''
      this.updateData.customer_process_note = ''
      this.updateData.customer_id_fk = null
      this.updateData.product_name = null
      this.updateData.product_url = null
      this.updateData.quantity = null
      this.updateData.color = null
      this.updateData.size = null
      this.updateData.note = null
      this.updateData.brand = null
      this.updateData.order_image = null
      this.checkAlert = false
    },

    processOrder(event, id, stime, stime1, stime2) {
      let token = localStorage.getItem('access_token')
      this.loading = true
      this.updateData.send_sms = this.updateData.send_sms.toString()

      const formData = new FormData()

      Object.keys(this.updateData).forEach(key => {
        if (key === 'customer_process_note_image' || key === 'order_image') return
        if (this.updateData[key] !== null && this.updateData[key] !== undefined) {
          formData.append(key, this.updateData[key])
        }
      })

      if (this.updateData.customer_process_note_image instanceof File) {
        formData.append('customer_process_note_image', this.updateData.customer_process_note_image)
      }

      if (this.updateData.order_image instanceof File) {
        formData.append('order_image', this.updateData.order_image)
      }

      axios.post(this.processOrderUrl + '/' + id, formData, {
        headers: { Authorization: 'Bearer ' + token }
      })
        .then((response) => {
          this.loading = false
          this.clearProcessOrderData()
          stime.time = ''
          stime1.time = ''
          stime2.time = ''
          this.checkAlert = true
          this.getResults()
          const message = response.data.message
          if (message && typeof message === 'object' && message.adjustment_note) {
            swal(this.$t('orders.orderUpdatedTitle'), message.adjustment_note, 'success')
          }
          let b = this
          setTimeout(function () {
            b.checkAlert = false
          }, 1500)
        })
        .catch((error) => {
          const rawMsg = error && error.response && error.response.data && error.response.data.message
          const msg = rawMsg && typeof rawMsg === 'object'
            ? Object.values(rawMsg).flat().join('\n')
            : (rawMsg || this.$t('orders.errorOccurredProcessingOrder'))
          swal(this.$t('common.error'), msg, 'error')
          this.loading = false
          this.clearProcessOrderData()
          stime.time = ''
          stime1.time = ''
          stime2.time = ''
        })
    },

    getReasons() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/reason/list', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let result = response.data
          this.reasons = result.map(r => ({
            text: r.cancel_reason,
            value: r.cancel_reason,
            ar: r.cancel_reason_ar,
            ku: r.cancel_reason_ku
          }))
        })
    },

    handleWarehouseFilter(val) {
      this.tableData.warehouse_id_fk = Array.isArray(val) && val.length ? val.join(',') : ''
      this.url = 'api/approved_order'
      this.getResults()
    },

    handlePlatformFilter(val) {
      this.tableData.platform = Array.isArray(val) && val.length ? val.join(',') : ''
      this.getResults()
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let data = response.data
          const isFlatArray = Array.isArray(data.data)
          if (isFlatArray) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }
          this.resultsVersion++

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (isFlatArray) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
        .catch((errors) => { })
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.tableData.warehouse_id_fk = ''
      this.tableData.platform = ''
      this.getResults()
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    modal(modal) {
      $('#' + modal).modal({ backdrop: 'static' })
    },

    closeModal(modal) {
      let theModal = $('#' + modal)
      theModal.modal('toggle')
    },

    initDetail(modal, id) {
      let token = localStorage.getItem('access_token')
      axios
        .get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let data = response.data
          this.detailResults = data.data

          this.detialData = this.detailResults[0]
        })
      this.modal(modal)
    },

    openPurchaseOrderModal(order) {
      this.purchaseOrderModal = true
      this.purchaseOrderID = order.order_id
      this.purchaseOrderData = { ...order }

      // Auto-fill defaults
      const today = new Date().toISOString().split('T')[0]

      // Default Kurdistan bank
      this.purchaseOrderData.bank_id = this.kurdistanBankId

      // Auto-fill actual price from order total_amount
      this.purchaseOrderData.actual_price = order.total_amount

      // Auto-fill Order Number: use existing barcode if set, otherwise use theOrderID
      this.purchaseOrderData.barcode = order.barcode || order.theOrderID

      // Warehouse date defaults to today if not set
      if (!this.purchaseOrderData.warehouse_date) {
        this.purchaseOrderData.warehouse_date = today
      }

      // From date defaults to today if not set
      if (!this.purchaseOrderData.from_date) {
        this.purchaseOrderData.from_date = today
      }

      // To date: use existing order to_date if set, else today + 7 days
      if (!this.purchaseOrderData.to_date) {
        const d = new Date()
        d.setDate(d.getDate() + 7)
        this.purchaseOrderData.to_date = d.toISOString().split('T')[0]
      }
    },

    closePurchaseOrderModal() {
      this.purchaseOrderModal = false
      this.successAlert = false
      this.clearPurchaseOrderModal()
    },

    clearPurchaseOrderModal() {
      this.purchaseOrderData.bank_id = this.kurdistanBankId
      this.purchaseOrderData.item_cost_in_tl = ''
      this.purchaseOrderData.item_cost_in_usd = ''
      this.purchaseOrderData.country = ''
      this.purchaseOrderData.purchase_note = ''
      this.purchaseOrderData.barcode = null
      this.purchaseOrderData.warehouse_date = null
      this.purchaseOrderData.from_date = null
      this.purchaseOrderData.to_date = null
      this.purchaseOrderData.ids = []
      this.purchaseOrderData.totalByCountry = null
    },

    purchaseOrder() {
      let token = localStorage.getItem('access_token')
      axios
        .put(this.purchaseOrderUrl + '/' + this.purchaseOrderID, this.purchaseOrderData, {
          headers: { Authorization: 'Bearer ' + token },
        })
        .then(() => {
          this.getResults()
          swal({
            title: this.$t('common.done'),
            text: this.$t('orders.orderPurchasedSuccessfully'),
            icon: 'success',
            timer: 1500,
            buttons: false,
          })
          // this.successAlert = true
          this.closePurchaseOrderModal()
        })
        .catch((error) => {
          if (error.response) {
            swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
          }
        })
      // swal({
      //   title: this.$t('common.areYouSure'),
      //   text: 'Once confirmed, selected order will be purchased',
      //   icon: 'warning',
      //   buttons: true,
      // }).then((approved) => {
      //   if (approved) {
      //     //
      //   }
      // })
    },

    openRefundOrderModal(orderId, totalAmount) {
      let token = localStorage.getItem('access_token')
      axios
        .get(`api/order/${orderId}/partial-refunds`, {
          headers: { Authorization: 'Bearer ' + token },
        })
        .then((res) => {
          this.refundData = {
            partial_refunds: res.data.data.partial_refunds,
            send_sms: false,
            money_amount: totalAmount,
            refund_note: 'full refund',
          }
          this.the_order_id = orderId
          this.theOrderTotalAmount = totalAmount
          this.refundOrderModal = true
        })
    },

    closeRefundOrderModal() {
      this.refundOrderModal = false
      this.checkAlert = false
      this.clear()
    },

    clear() {
      this.refundData = {
        send_sms: false,
      }
      this.theOrderTotalAmount = ''
      this.$validator.reset()
    },

    refundOrder() {
      let token = localStorage.getItem('access_token')
      this.loading = true
      axios
        .put(this.refundOrderUrl + '/' + this.the_order_id, this.refundData, {
          headers: { Authorization: 'Bearer ' + token },
        })
        .then((response) => {
          this.getResults()
          this.checkAlert = true
          this.loading = false
          this.clear()
          setTimeout(() => {
            this.closeRefundOrderModal()
          }, 1500)
        })
        .catch((error) => {
          // swal(this.$t('common.error'), 'There is an error please try again', 'error')
          if (error.response) {
            swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
          }
          this.getResults()
          this.loading = false
          // this.clear()
          // setTimeout(() => {
          //   this.closeRefundOrderModal()
          // }, 1500)
        })
    },

    openPartialRefundOrderModal(orderId, totalAmount) {
      let token = localStorage.getItem('access_token')
      axios.get(`api/order/${orderId}/partial-refunds`, { headers: { Authorization: 'Bearer ' + token } }).then(res => {
        this.partialRefundData = {
          order_id_fk: orderId,
          partial_refunds: res.data.data.partial_refunds,
          amount: totalAmount,
          note: this.$t('orders.partialRefundTooltip'),
        }
        this.theOrderTotalAmount = totalAmount
        this.partialRefundOrderModal = true
      })
    },

    closePartialRefundOrderModal() {
      this.partialRefundOrderModal = false
      this.checkAlert = false
      this.partialClear()
    },

    partialClear() {
      this.partialRefundData = {}
      this.theOrderTotalAmount = ''
      this.$validator.reset()
    },

    partialRefundOrder() {
      let token = localStorage.getItem('access_token')
      this.loading = true
      axios
        .post('api/partial-refund', this.partialRefundData, {
          headers: { Authorization: 'Bearer ' + token },
        })
        .then((response) => {
          this.getResults()
          this.checkAlert = true
          this.loading = false
          setTimeout(() => {
            this.clear()
            this.closePartialRefundOrderModal()
          }, 1500)
        })
        .catch((error) => {
          swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
          this.getResults()
          this.loading = false
        })
    },

    openAddBarcodeModal(id) {
      this.addBarcodeModal = true
      this.the_order_id2 = id
    },

    closeAddBarcodeModal() {
      this.addBarcodeModal = false
      this.addBarcodeData.barcode = ''
      this.checkAlert = false
    },

    addBarcode() {
      let token = localStorage.getItem('access_token')

      axios
        .put(this.addBarcodeUrl + '/' + this.the_order_id2, this.addBarcodeData, {
          headers: { Authorization: 'Bearer ' + token },
        })
        .then((response) => {
          this.getResults()
          this.checkAlert = true
          this.addBarcodeData.barcode = ''
        })
        .catch((error) => {
          this.addBarcodeData.barcode = ''
          swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
        })
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: this.$t('common.typeToSearch'),
          icon: 'warning',
          dangerMode: true,
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    },
  },
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td
{
  padding: 0 5px !important;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.icon-enlarge,
.icon-pencil {
  color: navy;
}

.icon-bin2 {
  color: red;
}

.icon-calendar {
  color: green;
}

.btn {
  transition: all 0.5s;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

.has-error .select2-selection--single:not([class*='bg-']):not([class*='border-']) {
  border-bottom-color: red;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 9999;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-color: #484b4e;
}

/* Mobile order cards: see assets/mobile-order-cards.css */

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

.customer-name-stack {
  display: inline-flex;
  flex-direction: column;
  vertical-align: middle;
}
.customer-phone-line {
  display: block;
  font-size: 14px;
  color: #666;
}
.combined-cell-td {
  vertical-align: middle;
}
.combined-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;
  font-size: 15px;
  line-height: 1.4;
  white-space: nowrap;
}
.combined-cell-label {
  color: #888;
}

/* Highlight the quantity (label + value) in light red when it is more than 1 */
.qty-flag {
  background: #ffcdd2;
  border-radius: 4px;
  padding: 0 6px;
  font-weight: 700;
  color: #b71c1c;
}
.qty-flag .combined-cell-label {
  color: #b71c1c;
}
.moc-row--2col .qty-flag {
  padding: 2px 6px;
}
.moc-row--2col .qty-flag .moc-label,
.moc-row--2col .qty-flag .moc-value {
  color: #b71c1c;
}
</style>



// WEBPACK FOOTER //
// src/components/approvedOrder.vue